$(".scroll-fade").inViewport(function (px) {
  if (px > 0) {
    const h = $(this).outerHeight()
    const wh = $(window).height()
    let opacity = px / $(this).outerHeight()
    if (opacity > 1) {
      opacity = 1
    }
    $(this).css("--opacity", opacity)
  } else {
    $(this).css("--opacity", 0)
  }
})

$(
  ".section-solutions .wrapper, .section-industries .splide, .section-studies .splide, .section-services .wrapper, .section-customers .wrapper, .section-testimonials .splide",
).inViewport(function (px) {
  if (px > 0) {
    $(this)
      .addClass("active")
      .css("--height", $(this).outerHeight() + "px")
  } else {
    $(this)
      .removeClass("active")
      .css("--height", $(this).outerHeight() + "px")
  }
})
